{
  "account.copy": "Copiar",
  "account.created.claudeCode": "Claude Code",
  "account.created.done": "Hecho",
  "account.created.json": "Clientes que se configuran con JSON (por ejemplo el .mcp.json de un proyecto)",
  "account.created.once": "Copia el token ahora. Solo se muestra esta vez; KSS guarda únicamente una huella de él.",
  "account.created.title": "Token «{name}»",
  "account.expiry.1y": "un año",
  "account.expiry.30d": "30 días",
  "account.expiry.90d": "90 días",
  "account.expiry.never": "no caduca nunca",
  "account.mcp": "Conector MCP",
  "account.mcp.address": "Dirección del conector:",
  "account.mcp.disabled": "Un administrador ha desactivado el conector MCP.",
  "account.mcp.sub": "Deja que un asistente de IA trabaje con KSS en tu nombre. Puede hacer lo que tú puedes, dentro de los límites de su token.",
  "account.refused.admin_only": "Solo los administradores pueden crear un token con administración del servidor.",
  "account.refused.disabled": "El conector MCP está desactivado.",
  "account.refused.expiry": "Elige cuándo caduca el token.",
  "account.refused.name": "Ponle un nombre al token.",
  "account.refused.rights": "Estos permisos no existen.",
  "account.refused.too_many": "Ya tienes tantos tokens como se permiten. Revoca uno primero.",
  "account.refused.workspace": "Elige solo espacios de trabajo a los que perteneces.",
  "account.rights.admin": "Leer, escribir y administrar el servidor",
  "account.rights.read": "Leer",
  "account.rights.write": "Leer y escribir",
  "account.title": "Cuenta",
  "account.tokens": "Tokens",
  "account.tokens.allWorkspaces": "todos los espacios de trabajo",
  "account.tokens.allWorkspacesLong": "Todos mis espacios de trabajo, también los futuros",
  "account.tokens.create": "Crear token",
  "account.tokens.expires": "caduca: {date}",
  "account.tokens.expiry": "Caduca tras",
  "account.tokens.lastUsed": "último uso: {date}",
  "account.tokens.name": "Nombre",
  "account.tokens.namePlaceholder": "p. ej. Claude en mi portátil",
  "account.tokens.never": "nunca",
  "account.tokens.new": "Nuevo token…",
  "account.tokens.none": "Todavía no hay tokens.",
  "account.tokens.notYet": "todavía no",
  "account.tokens.revoke": "Revocar",
  "account.tokens.revoked": {
    "one": "{count} token revocado",
    "other": "{count} tokens revocados"
  },
  "account.tokens.rights": "Permisos",
  "account.tokens.workspaces": "Espacios de trabajo",
  "app.account": "Tu cuenta y tokens de MCP",
  "app.handbook": "Manual",
  "app.help": "Ayuda sobre esta página",
  "app.language": "Idioma de la interfaz",
  "app.logOut": "Cerrar sesión",
  "auth.adminOnly": "Aquí solo la administración puede iniciar sesión con contraseña.",
  "auth.adminSignIn": "Acceso de administración",
  "auth.error.failed": "El inicio de sesión no se completó. Inténtalo de nuevo.",
  "auth.error.group": "Tu cuenta no tiene permiso para usar KSS. Pide acceso a una persona administradora.",
  "auth.error.unavailable": "El servicio de inicio de sesión no está disponible ahora mismo.",
  "auth.invalid": "Credenciales no válidas.",
  "auth.orLocal": "o con una cuenta local",
  "auth.password": "Contraseña",
  "auth.passwordDisabled": "El inicio de sesión con contraseña está desactivado.",
  "auth.signIn": "Iniciar sesión en el Knowledge Storage System",
  "auth.submit": "Iniciar sesión",
  "auth.username": "Nombre de usuario",
  "auth.withProvider": "Iniciar sesión con {provider}",
  "block.add": "Añadir bloque",
  "block.copied": {
    "one": "{count} bloque copiado",
    "other": "{count} bloques copiados"
  },
  "block.drag": "Arrastrar bloque",
  "block.drag.title": "Arrastra para mover · Ctrl/⌘-clic para seleccionar",
  "block.drag.titleReadOnly": "Ctrl/⌘-clic para seleccionar",
  "block.emptyPage": "Página vacía.",
  "block.issues.dangling_link": "enlace colgante",
  "block.issues.deprecated_term": "término obsoleto",
  "block.issues.derived_edge": "enlace sugerido",
  "block.issues.grounding": "pregunta de asignación",
  "block.issues.lww_conflict": "edición en conflicto",
  "block.issues.shacl_violation": "infracción de forma",
  "block.menu": "Menú del bloque",
  "block.menu.copy": "Copiar",
  "block.menu.copyIri": "Copiar el IRI del bloque",
  "block.menu.copyN": "Copiar {count} bloques",
  "block.menu.delete": "Eliminar",
  "block.menu.detach": "Desvincular (hacer una copia)",
  "block.menu.down": "Bajar",
  "block.menu.intoGroup": "Mover al grupo de arriba",
  "block.menu.link": "Enlazar…",
  "block.menu.links": "Enlaces…",
  "block.menu.openOriginal": "Abrir el original",
  "block.menu.outOfGroup": "Sacar del grupo",
  "block.menu.pasteAfter": "Pegar después…",
  "block.menu.pasteInto": "Pegar en el grupo…",
  "block.menu.role": "Asignar rol…",
  "block.menu.sequence": "Añadir a secuencia…",
  "block.menu.untitledSequence": "(sin título)",
  "block.menu.up": "Subir",
  "block.mirror.confirmDelete": "Esto elimina el bloque de «{source}» y de todos sus espejos.",
  "block.mirror.unavailable": "El original no está disponible, así que no se puede desvincular el espejo.",
  "block.none": "No hay bloques.",
  "block.paste": "Pegar",
  "block.resize": "Cambiar el tamaño del bloque",
  "block.resize.title": "Arrastra para cambiar el tamaño · doble clic para restablecer",
  "block.type.audio": "Audio",
  "block.type.checklist": "Lista de tareas",
  "block.type.chemistry": "Estructura química",
  "block.type.code": "Código",
  "block.type.externalVideo": "Vídeo externo",
  "block.type.file": "Archivo",
  "block.type.graphView": "Vista de grafo",
  "block.type.group": "Grupo",
  "block.type.image": "Imagen",
  "block.type.mermaid": "Diagrama Mermaid",
  "block.type.mirror": "Espejo",
  "block.type.pageLink": "Enlace a una página",
  "block.type.reaction": "Reacción",
  "block.type.section": "Sección de texto",
  "block.type.table": "Tabla",
  "block.type.url": "URL",
  "block.type.video": "Vídeo",
  "block.type.webpage": "Página web",
  "checklist.add": "Añadir elemento",
  "checklist.delete": "Eliminar elemento",
  "checklist.done": "Hecho",
  "checklist.drag": "Arrastrar elemento",
  "checklist.hideDone": "ocultar completadas",
  "checklist.progress": "{done} / {total} hechas",
  "checklist.title": "Lista de tareas",
  "checklist.todo": "Por hacer",
  "chem.changedRemotely": "Cambiado por otra persona",
  "chem.edit": "Editar",
  "chem.empty": "Todavía no hay estructura.",
  "chem.emptyEdit": "Todavía no hay estructura: haz clic en Editar para dibujar una.",
  "chem.kind.molecule": "molécula",
  "chem.kind.reaction": "reacción",
  "chem.loading": "Cargando Ketcher…",
  "chem.needArrow": "Dibuja primero una flecha de reacción: un bloque de reacción solo guarda reacciones.",
  "chem.overwrite": "Sobrescribir con la mía",
  "chem.reloadRemote": "Cargar la otra versión",
  "chem.title.reaction": "Reacción",
  "chem.title.structure": "Estructura química",
  "code.label": "código",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.done": "Listo",
  "common.edit": "editar",
  "common.label": "Etiqueta",
  "common.loading": "Cargando…",
  "common.remove": "quitar",
  "common.removeEntry": "Quitar",
  "common.save": "Guardar",
  "concepts.delete": "Eliminar el concepto",
  "concepts.empty": "Todavía no hay conceptos en el espacio de trabajo.",
  "concepts.new": "Nuevo concepto",
  "concepts.title": "Conceptos",
  "delete.body": "La página pasa a la papelera del espacio de trabajo, desde donde se puede restaurar. Los enlaces de otras páginas a sus bloques aparecen como colgantes en la bandeja de revisión hasta que vuelva. No se borra nada: se conservan su historial y sus archivos.",
  "delete.dialog": "Eliminar página",
  "delete.heading": "¿Eliminar «{title}»?",
  "export.button": "Exportar…",
  "export.notes": {
    "one": "{count} nota en el manifiesto del archivo.",
    "other": "{count} notas en el manifiesto del archivo."
  },
  "export.offline": "La exportación necesita el servidor",
  "export.preparing": "Preparando el archivo…",
  "export.title": "Exportar esta página y sus archivos como archivo .kss.zip",
  "export.unsynced": "Los cambios sin sincronizar no se incluyen.",
  "extract.failed": "falló",
  "extract.failedWith": "falló: {error}",
  "extract.progress": "extrayendo {done}/{total}…",
  "extract.run": "Extraer",
  "extract.title": "Extraer candidatos para el grafo de conocimiento de esta página con el modelo de lenguaje",
  "extract.triples": {
    "one": "{count} tripleta candidata",
    "other": "{count} tripletas candidatas"
  },
  "file.download": "descargar",
  "file.downloadButton": "Descargar",
  "file.inA": "en una",
  "file.inline": "abrir en el navegador",
  "file.name": "archivo",
  "file.newTab": "pestaña nueva",
  "file.newWindow": "ventana nueva",
  "file.offline": "no disponible sin conexión",
  "file.open": "Abrir",
  "file.unknownType": "tipo desconocido",
  "file.whenOpened": "Al abrir",
  "graph.autoCentre": "Centrar al volver a ejecutar",
  "graph.blockTitle": "Vista de grafo",
  "graph.builder.error": "No se pudo cargar el constructor de consultas. El editor SPARQL de abajo sigue funcionando.",
  "graph.builder.loading": "Cargando el constructor de consultas…",
  "graph.builder.open": "Construir una consulta",
  "graph.builder.openBlock": "Construir consulta…",
  "graph.builder.use": "Usar la consulta",
  "graph.choosePage": "Elige una página…",
  "graph.fit": "Ajustar el grafo",
  "graph.graphView": "vista de grafo",
  "graph.groupByPage": "agrupar por página",
  "graph.hideDerived": "ocultar duplicados derivados",
  "graph.insertPrefixes": "Insertar prefijos",
  "graph.layout.elk": "ELK por capas",
  "graph.layout.preset": "guardado",
  "graph.nodes": {
    "one": "{count} nodo",
    "other": "{count} nodos"
  },
  "graph.rows": {
    "one": "{count} fila",
    "other": "{count} filas"
  },
  "graph.run": "Ejecutar",
  "graph.runHint": "Ctrl/⌘-Enter ejecuta",
  "graph.running": "ejecutando…",
  "graph.saveAsBlock": "Guardar como bloque",
  "graph.staleSince": "desactualizado desde {time}",
  "graph.tableView": "vista de tabla",
  "graph.template.annotations": "Anotaciones de un bloque",
  "graph.template.blocksByPage": "Todos los bloques y sus páginas",
  "graph.template.chebi": "Bloques que mencionan una entidad química (subclases de ChEBI)",
  "graph.template.derivedPending": "Enlaces derivados pendientes de revisión",
  "graph.template.inchikeys": "Estructuras y participantes por InChIKey",
  "graph.template.neighbourhood": "Vecindario de un bloque",
  "graph.template.pageLinks": "Todos los enlaces de una página",
  "graph.template.sequences": "Miembros de secuencias",
  "graph.templates": "Plantillas",
  "graph.toggleEditor": "Mostrar u ocultar el editor de consultas",
  "graph.tooLarge": "resultado grande: vista de tabla",
  "graph.truncated": "truncado",
  "graph.typeEdges": "aristas de tipo",
  "graph.zoom": "Zoom",
  "graph.zoomIn": "Acercar",
  "graph.zoomOut": "Alejar",
  "group.collapse": "Plegar el grupo",
  "group.expand": "Desplegar el grupo",
  "group.title": "Título del grupo",
  "image.alt": "Texto alternativo",
  "import.blocks": {
    "one": "{count} bloque",
    "other": "{count} bloques"
  },
  "import.button": "Importar página…",
  "import.files": {
    "one": "{count} archivo",
    "other": "{count} archivos"
  },
  "import.importing": "Importando…",
  "import.links": {
    "one": "{count} enlace del espacio de trabajo",
    "other": "{count} enlaces del espacio de trabajo"
  },
  "import.offline": "La importación necesita el servidor",
  "import.open": "Abrir la página",
  "import.refused": "Importación rechazada: {error}",
  "import.sequences": {
    "one": "{count} secuencia",
    "other": "{count} secuencias"
  },
  "import.summary": "Importada «{title}»: {blocks}, {files}; conceptos: emparejados {matched}, creados {created}; {sequences}, {links}.",
  "import.title": "Importar como página nueva una página exportada de KSS (.kss.zip)",
  "import.tooLarge": "el archivo es demasiado grande",
  "import.uploadFailed": "la subida falló",
  "import.uploading": "Subiendo… {percent} %",
  "inspector.copyIri": "Copiar IRI",
  "inspector.edges": "Aristas ({count})",
  "inspector.empty": "Selecciona un nodo para inspeccionarlo. Un doble clic despliega sus vecinos.",
  "inspector.expand": "Expandir",
  "inspector.open": "Abrir",
  "inspector.properties": "Propiedades",
  "inspector.stale": "desactualizado",
  "inspector.style": "estilo {style}",
  "inspector.types": "Tipos",
  "inspector.variables": "Variables del resultado",
  "linkDialog.add": "Añadir enlace",
  "linkDialog.chooseTarget": "Elige un destino",
  "linkDialog.datatype": "Tipo de dato",
  "linkDialog.deprecated": "obsoleto",
  "linkDialog.noConcepts": "Todavía no hay conceptos en el espacio de trabajo: crea uno en la barra lateral del espacio.",
  "linkDialog.note": "Nota (opcional)",
  "linkDialog.only": "solo términos de tipo {class}",
  "linkDialog.otherIri": "Otro IRI…",
  "linkDialog.page": "página",
  "linkDialog.predicate": "Predicado",
  "linkDialog.search": "Buscar…",
  "linkDialog.tab.blocks": "Bloques",
  "linkDialog.tab.concepts": "Conceptos",
  "linkDialog.tab.iri": "IRI",
  "linkDialog.tab.literal": "Valor",
  "linkDialog.tab.terms": "Términos de ontología",
  "linkDialog.takesType": "Este predicado espera un valor de tipo {type}.",
  "linkDialog.target": "Destino",
  "linkDialog.title": "Enlazar este bloque",
  "linkDialog.unconstrained": "Sin ninguna forma que lo restrinja: este predicado está fuera de las ontologías importadas.",
  "linkDialog.valueNotLink": "Un valor en lugar de un enlace a algo.",
  "linkDialog.workspaceConcept": "concepto del espacio de trabajo",
  "links.close": "cerrar",
  "links.facts": "Datos",
  "links.facts.about": "Sobre (opcional)",
  "links.facts.aboutLabel": "sobre {term}",
  "links.facts.add": "Añadir dato",
  "links.facts.kind": "Tipo",
  "links.facts.lead": "Valores declarados sobre este bloque.",
  "links.facts.noKind": "(sin tipo)",
  "links.facts.note": "Nota",
  "links.facts.remove": "Quitar dato",
  "links.facts.unit": "Unidad",
  "links.facts.value": "Valor",
  "links.from": "desde {source}",
  "links.group.alternatives": "Alternativas",
  "links.group.any": "cualquier combinación",
  "links.group.atLeastOne": "al menos una",
  "links.group.cancel": "cancelar",
  "links.group.choose": "Elegir esta opción",
  "links.group.create": {
    "one": "Agrupar {count} enlace",
    "other": "Agrupar {count} enlaces"
  },
  "links.group.custom": "entre n y m…",
  "links.group.dissolve": "disolver",
  "links.group.exactlyN": "exactamente {n}",
  "links.group.exactlyOne": "exactamente una",
  "links.group.labelPlaceholder": "Etiqueta (opcional), p. ej. Almacenamiento",
  "links.group.orMore": "{min} o más",
  "links.group.range": "de {min} a {max}",
  "links.group.takeOut": "Sacar del grupo",
  "links.group.tooMany": "demasiados elegidos",
  "links.group.ungroup": "desagrupar",
  "links.groupAsAlternatives": "Agrupar como alternativas…",
  "links.incoming": "Entrantes",
  "links.incomingNeedServer": "Sin conexión: los enlaces entrantes requieren el servidor.",
  "links.none": "Todavía no hay enlaces.",
  "links.noneShort": "Ninguno.",
  "links.outgoing": "Salientes",
  "links.promoted": "aceptado de la extracción",
  "links.prov.asserted": "afirmado",
  "links.prov.computed": "calculado",
  "links.prov.derived": "derivado",
  "links.prov.ontology": "ontología",
  "links.remove": "Quitar enlace",
  "links.select": "Seleccionar enlace",
  "links.short.block": "bloque {id}",
  "links.short.concept": "concepto {id}",
  "links.short.page": "página",
  "links.title": "Enlaces",
  "literal.aValue": "un valor",
  "literal.needLang": "hace falta una etiqueta de idioma, p. ej. en o es",
  "literal.needValue": "hace falta un valor",
  "literal.not.boolean": "no es un valor booleano",
  "literal.not.date": "no es una fecha",
  "literal.not.dateTime": "no es una fecha con hora",
  "literal.not.decimal": "no es un número decimal",
  "literal.not.integer": "no es un número entero",
  "literal.notDate": "no es una fecha válida",
  "literal.notUri": "no es un URI",
  "literal.type.boolean": "booleano",
  "literal.type.date": "fecha",
  "literal.type.dateTime": "fecha y hora",
  "literal.type.decimal": "número decimal",
  "literal.type.integer": "número entero",
  "literal.type.langString": "texto con idioma",
  "literal.type.string": "cadena",
  "literal.type.text": "texto",
  "literal.type.uri": "URI",
  "media.caption": "Pie",
  "media.choose": "elige un archivo",
  "media.drop": "Suelta un archivo aquí o",
  "media.hashing": "calculando la huella… {percent} %",
  "media.none": "Sin contenido multimedia",
  "media.offline": "{name} (no disponible sin conexión)",
  "media.replace": "reemplazar",
  "media.uploadFailed": "error al subir: {error}",
  "media.uploadState.queued": "en cola… {percent} %",
  "media.uploadState.uploading": "subiendo… {percent} %",
  "mermaid.hideSource": "ocultar el código",
  "mermaid.showSource": "mostrar el código",
  "mirror.blockOn": "un bloque de «{title}»",
  "mirror.deleted": "El original se eliminó.",
  "mirror.forbidden": "No puedes leer el original.",
  "mirror.loop": "Bucle de espejos: este espejo se muestra a sí mismo.",
  "mirror.noOriginal": "Este espejo no tiene original.",
  "mirror.of": "Espejo de",
  "mirror.offline": "El original no está disponible sin conexión.",
  "mirror.otherWorkspace": "El original no está en este espacio de trabajo.",
  "mirror.page": "«{title}»",
  "mirror.tooDeep": "Los espejos están anidados a demasiada profundidad para mostrarlos aquí.",
  "offline.caching": "guardando…",
  "offline.cachingProgress": "guardando {done}/{total}",
  "offline.pin": "fijar",
  "offline.pinned": "sin conexión",
  "offline.title": "Disponible sin conexión",
  "page.backToWorkspace": "← Espacio de trabajo",
  "page.copied": "Copiado",
  "page.copyAll": "Copiar todos los bloques",
  "page.copyAll.title": "Copiar todos los bloques de esta página (pegar como copia, espejo o estructura vacía)",
  "page.opening": "Abriendo la página…",
  "page.titlePlaceholder": "Página sin título",
  "page.untitled": "Sin título",
  "page.width": "Ancho de página",
  "page.width.full": "Ancho completo",
  "page.width.narrow": "Estrecho",
  "page.width.wide": "Ancho",
  "pageActions.delete": "Eliminar página…",
  "pageActions.delete.readOnly": "No puedes editar esta página",
  "pageActions.linkPage": "Enlazar la página…",
  "pageActions.menu": "Acciones de la página",
  "pageActions.restrict": "Restringir la escritura…",
  "pageActions.restrict.ownerOnly": "Solo un propietario puede restringir la escritura",
  "pageLink.change": "Elegir página…",
  "pageLink.missing": "La página ya no existe o no puedes leerla.",
  "pageLink.noMatch": "Ninguna página coincide.",
  "pageLink.none": "Todavía no se ha elegido una página.",
  "pageLink.offline": "Sin conexión: la lista de páginas necesita el servidor.",
  "pageLink.search": "Buscar páginas…",
  "pageLink.trashed": "«{title}» está en la papelera.",
  "paste.dialog": "Pegar bloques",
  "paste.mode.copy": "Copiar el contenido",
  "paste.mode.copyHint": "Bloques independientes con el mismo contenido; editarlos no cambia los originales.",
  "paste.mode.empty": "Estructura vacía",
  "paste.mode.emptyHint": "Los mismos bloques y anidamiento con títulos, sin contenido ni enlaces.",
  "paste.mode.mirror": "Reflejar",
  "paste.mode.mirrorHint": "Muestra los originales en vivo: editar uno cambia ambos.",
  "paste.paste": "Pegar",
  "paste.pasting": "Pegando…",
  "paste.refuse.block": "Un bloque no se puede reflejar dentro de sí mismo.",
  "paste.refuse.missing": "Un original ya no está en su página.",
  "paste.refuse.page": "Una página no puede reflejarse a sí misma.",
  "paste.title.afterBlock": "Pegar después de este bloque",
  "paste.title.afterSelection": "Pegar después de la selección",
  "paste.title.atEnd": "Pegar al final de la página",
  "paste.title.intoGroup": "Pegar en este grupo",
  "paste.whatBlocks": {
    "one": "{count} bloque de «{title}»",
    "other": "{count} bloques de «{title}»"
  },
  "paste.whatPage": {
    "one": "toda la página «{title}»: {count} bloque",
    "other": "toda la página «{title}»: {count} bloques"
  },
  "rail.addQuery": "Añadir desde una consulta…",
  "rail.arrow": "Flecha",
  "rail.arrow.both": "en ambos extremos",
  "rail.arrow.none": "ninguna",
  "rail.arrow.target": "en el destino",
  "rail.button": "Relaciones",
  "rail.cached": "resultado en caché (sin conexión)",
  "rail.closeStyle": "Cerrar el editor de estilos",
  "rail.colour": "Color",
  "rail.dash.dashdot": "raya y punto",
  "rail.dash.dashed": "discontinua",
  "rail.dash.dotted": "punteada",
  "rail.dash.solid": "continua",
  "rail.defaultStyle": "predeterminado",
  "rail.dialog.add": "Añadir una pista de consulta",
  "rail.dialog.edit": "Editar la pista de consulta",
  "rail.dialog.intro": "Cada fila del resultado dibuja un conector: <b>?source</b> y <b>?target</b> deben ser bloques de esta página; <b>?label</b> es opcional. Los resultados se guardan en caché, así que la pista se dibuja también sin conexión.",
  "rail.editStyle": "Editar el estilo",
  "rail.elsewhere": "{count} en otro sitio, sin dibujar",
  "rail.line": "Línea",
  "rail.newStyle": "Nuevo estilo…",
  "rail.none": "Todavía no hay enlaces entre bloques en esta página.",
  "rail.offPage": {
    "one": "{count} enlace va a bloques de otras páginas y no se dibuja.",
    "other": "{count} enlaces van a bloques de otras páginas y no se dibujan."
  },
  "rail.offPageCount": "{count} fuera de la página",
  "rail.onPage": "Relaciones en esta página",
  "rail.query": "Consulta",
  "rail.queryFailed": "La consulta falló: {error}",
  "rail.queryTracks": "Pistas de consulta",
  "rail.rerun": "volver a ejecutar",
  "rail.retry": "reintentar",
  "rail.rowsOnPage": {
    "one": "{count} fila en esta página",
    "other": "{count} filas en esta página"
  },
  "rail.show": "Mostrar la barra de relaciones",
  "rail.showLabel": "etiqueta",
  "rail.showPredicate": "Mostrar {label}",
  "rail.side": "Lado",
  "rail.side.left": "izquierda",
  "rail.side.right": "derecha",
  "rail.style": "Estilo",
  "rail.styleScope": "— se usa en todas las páginas de este espacio de trabajo",
  "rail.width": "Grosor",
  "rail.ws.blockLinks": "Mostrar también los enlaces entre los bloques de las páginas, contados",
  "rail.ws.offTree": {
    "one": "{count} enlace va a una página que no está en el árbol y no se dibuja.",
    "other": "{count} enlaces van a páginas que no están en el árbol y no se dibujan."
  },
  "reaction.addAgent": "Añadir agente",
  "reaction.addCondition": "Añadir condición",
  "reaction.addQuantity": "Añadir cantidad",
  "reaction.agents": "Agentes",
  "reaction.coefficients": "Coeficientes",
  "reaction.conditions": "Condiciones",
  "reaction.drawFirst": "Dibuja primero la reacción.",
  "reaction.drawnCount": "Vacío: usar la cantidad dibujada",
  "reaction.empty": "Todavía no hay reacción.",
  "reaction.emptyEdit": "Todavía no hay reacción: haz clic en Editar para dibujar una.",
  "reaction.kind": "Tipo",
  "reaction.label": "reacción",
  "reaction.note": "Nota",
  "reaction.quantities": "Cantidades",
  "reaction.role.catalyst": "catalizador",
  "reaction.role.reagent": "reactivo",
  "reaction.role.solvent": "disolvente",
  "reaction.species": "Especie (ChEBI)",
  "reaction.type": "Tipo de reacción",
  "reaction.typePlaceholder": "Reacción con nombre (RXNO)",
  "reaction.unit": "Unidad",
  "reaction.value": "Valor",
  "restrict.body": "Un miembro restringido aún puede <b>leer</b> esta página: la lectura abarca todo el espacio de trabajo. El contenido que algunos miembros no deben leer va en un espacio de trabajo aparte. Quien esté editando la página ahora quedará desconectado de ella.",
  "restrict.dialog": "Restringir la escritura",
  "restrict.heading": "Restringir la escritura en «{title}»",
  "restrict.onlyViewers": "Aquí solo hay lectores; de todos modos no pueden escribir.",
  "results.showing": "Se muestran {shown} de {total} filas.",
  "review.conflict.empty": "(vacío)",
  "review.conflict.peer": "participante {peer}",
  "review.conflict.title": "Ediciones en conflicto de <b>{key}</b>",
  "review.conflict.use": "Usar esta versión",
  "review.dangling.deleted": "El destino se eliminó; restáuralo o quita el enlace de su bloque.",
  "review.dangling.from": "Desde",
  "review.dangling.missing": "El destino no está; puede volver al deshacer o restaurar, y entonces este elemento se resuelve solo.",
  "review.dangling.title": "Un enlace apunta a algo que ya no existe",
  "review.dangling.to": "a",
  "review.deprecated.apply": "Aplicar el sustituto",
  "review.deprecated.auto": {
    "one": "Sustituido automáticamente en {count} lugar.",
    "other": "Sustituido automáticamente en {count} lugares."
  },
  "review.deprecated.noReplacement": "La ontología no indica sustituto; vuelve a enlazar a mano.",
  "review.deprecated.notAuto": "No se sustituyó automáticamente: {reason}",
  "review.deprecated.reason.auto_off": "la sustitución automática está desactivada en este espacio de trabajo.",
  "review.deprecated.reason.breaks_shape": "el sustituto incumpliría una regla (SHACL) donde se usa el término.",
  "review.deprecated.reason.chain_too_long": "la cadena de sustitutos es demasiado larga.",
  "review.deprecated.reason.cycle": "los sustitutos remiten unos a otros en círculo.",
  "review.deprecated.reason.kind_mismatch": "el sustituto es otro tipo de término (por ejemplo, una relación en vez de una clase).",
  "review.deprecated.reason.no_replacement": "la ontología no nombra ningún sustituto.",
  "review.deprecated.reason.not_imported": "el sustituto aún no está importado; la administración lo añade al archivo de términos de la ontología.",
  "review.deprecated.reason.several_replacements": "la ontología nombra más de un sustituto.",
  "review.deprecated.replacement": "Sustituto:",
  "review.deprecated.revert": "Deshacer",
  "review.deprecated.reverted": "Deshecho: el término antiguo vuelve a estar donde estaba el sustituto.",
  "review.deprecated.usedBy": {
    "one": "está obsoleto · se usa en {count} documento",
    "other": "está obsoleto · se usa en {count} documentos"
  },
  "review.dismiss": "Descartar",
  "review.edge.confidence": "confianza {value}",
  "review.edge.derived": "derivado",
  "review.edge.promote": "Aceptar",
  "review.edge.reject": "Rechazar",
  "review.empty": "No hay nada que revisar.",
  "review.fact.about": "sobre {term}",
  "review.fact.promote": "Añadir como dato",
  "review.factUnit.ambiguous": "Esto puede ser más de una unidad. Elige la que quiere decir el texto.",
  "review.factUnit.unknown": "KSS no conoce ninguna unidad escrita así para esta magnitud. Elige la que quiere decir el texto o descártalo.",
  "review.grounding.best": "mejor puntuación {score}",
  "review.grounding.choose": "Elegir",
  "review.grounding.conceptLabel": "Etiqueta del concepto",
  "review.grounding.createConcept": "Crear concepto",
  "review.grounding.in": "en",
  "review.grounding.noMatch": "sin coincidencia cercana",
  "review.grounding.suggested": "tipo sugerido: {type}",
  "review.grounding.typeTitle": "El tipo que sugirió el modelo; solo acota la búsqueda de candidatos y no se guarda",
  "review.kind.dangling_link": "Enlaces colgantes",
  "review.kind.deprecated_term": "Términos obsoletos",
  "review.kind.derived_edge": "Enlaces derivados",
  "review.kind.fact_unit": "Unidades por elegir",
  "review.kind.grounding": "Asignación",
  "review.kind.lww_conflict": "Conflictos",
  "review.kind.shacl_violation": "SHACL",
  "review.loadError": "No se pudieron cargar los elementos de revisión (solo con conexión).",
  "review.openBlock": "abrir bloque",
  "review.shacl.default": "Infracción de SHACL",
  "review.shacl.focus": "Nodo foco:",
  "review.shacl.path": "ruta",
  "review.shacl.value": "valor",
  "review.status.dismissed": "Descartados",
  "review.status.open": "Abiertos",
  "review.status.resolved": "Resueltos",
  "review.title": "Revisión",
  "role.editor": "editor",
  "role.intro": "Un rol dice lo que el bloque <b>es</b>: una cuestión, una postura, un paso. Se permiten varios.",
  "role.offline": "Sin conexión: la lista de roles necesita el servidor.",
  "role.owner": "propietario",
  "role.search": "Buscar roles…",
  "role.title": "¿Qué es este bloque?",
  "role.viewer": "lector",
  "section.empty": "Sección vacía",
  "section.mode.markdown": "Markdown",
  "section.mode.rendered": "Renderizado",
  "section.mode.wysiwym": "WYSIWYM",
  "section.viewMode": "Modo de vista",
  "seq.block": "bloque {id}",
  "seq.create": "Crear secuencia",
  "seq.delete": "Eliminar la secuencia",
  "seq.empty": "Todavía no hay secuencias.",
  "seq.hint": "Añade bloques desde el menú de un bloque.",
  "seq.moveDown": "Bajar",
  "seq.moveUp": "Subir",
  "seq.name": "Nombre de la secuencia",
  "seq.new": "Nueva secuencia",
  "seq.title": "Secuencias",
  "seq.untitled": "(sin título)",
  "server.adminsOnly": "Esta página es para administradores.",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.bundle": "agrupados en haz",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.separate": "líneas separadas con llave",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.larger": "el haz más grande",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.origin": "siempre el haz de origen",
  "server.discard": "Descartar",
  "server.environment": "Entorno",
  "server.environment.sub": "Definidos en .env y leídos al arrancar. Cambiarlos requiere reiniciar el servidor.",
  "server.error.choice": "Elige uno de los valores ofrecidos.",
  "server.error.host": "{host} no está en la lista de hosts de modelos permitidos del servidor (KM_LLM_ALLOWED_HOSTS en .env).",
  "server.error.integer": "Introduce un número entero.",
  "server.error.length": "Es demasiado largo; como máximo {max} caracteres.",
  "server.error.password": "La contraseña es demasiado débil.",
  "server.error.range": "Introduce un valor de {min} a {max}.",
  "server.error.required": "No puede estar vacío.",
  "server.error.type": "No es el tipo de valor correcto.",
  "server.error.unknown": "Este ajuste no se puede cambiar aquí.",
  "server.error.url": "Introduce una dirección http o https.",
  "server.group.decision": "Modelo de decisión",
  "server.group.decision.sub": "Un segundo modelo opcional que elige entre candidatos de anclaje.",
  "server.group.extraction": "Extracción",
  "server.group.extraction.sub": "Cuánto de una página y sus archivos lee una extracción.",
  "server.group.graph": "Consultas al grafo",
  "server.group.graph.sub": "Límites para las consultas al grafo de conocimiento.",
  "server.group.llm": "Modelo de lenguaje",
  "server.group.llm.sub": "El modelo que extrae entidades y relaciones de las páginas.",
  "server.group.mcp": "Conector MCP",
  "server.group.mcp.sub": "Asistentes de IA que trabajan con KSS mediante los tokens de las personas.",
  "server.group.rail": "Barra de relaciones",
  "server.group.rail.sub": "Cómo dibuja la barra de relaciones junto a las páginas los conectores que comparten un extremo.",
  "server.group.sessions": "Sesiones",
  "server.group.sessions.sub": "Conexiones de las páginas abiertas con el servidor de sincronización.",
  "server.group.signin": "Inicio de sesión",
  "server.group.signin.sub": "Cómo se inicia sesión.",
  "server.group.transfer": "Archivos de páginas",
  "server.group.transfer.sub": "Exportar e importar páginas.",
  "server.group.web": "Páginas web",
  "server.group.web.sub": "Navegar y congelar páginas web en bloques de página web.",
  "server.hidden": "El entorno fija {value}; el valor guardado aquí lo sustituye.",
  "server.history": "Historial",
  "server.history.command": "Un comando del servidor",
  "server.history.empty": "(vacío)",
  "server.history.mcp.token_created": "creó el token MCP «{user}».",
  "server.history.mcp.token_revoked": "revocó el token MCP «{user}».",
  "server.history.mcp.tokens_revoked": "revocó todos los tokens MCP de {user}.",
  "server.history.mcp.write": "cambió {user} mediante el conector MCP.",
  "server.history.more": "Mostrar anteriores",
  "server.history.none": "Todavía no se ha cambiado nada.",
  "server.history.setting.reset": "restableció {setting} de {before} a {after}.",
  "server.history.setting.saved": "cambió {setting} de {before} a {after}.",
  "server.history.sub": "Cada cambio hecho en esta página, el más reciente primero. Las claves se registran como cambiadas, nunca su valor.",
  "server.history.user.active.off": "desactivó a {user}.",
  "server.history.user.active.on": "reactivó a {user}.",
  "server.history.user.admin.off": "quitó los derechos de administrador a {user}.",
  "server.history.user.admin.on": "hizo administrador a {user}.",
  "server.history.user.created": "creó el usuario {user}.",
  "server.history.user.edited": "cambió {fields} de {user}.",
  "server.history.user.password": "fijó una contraseña nueva para {user}.",
  "server.link": "Ajustes del servidor",
  "server.needServer": "Esto necesita el servidor.",
  "server.reset": "Restablecer",
  "server.save": "Guardar",
  "server.saved": "Guardado.",
  "server.secret.clear": "Vaciar",
  "server.secret.new": "Clave nueva",
  "server.secret.notSet": "sin definir",
  "server.secret.replace": "Sustituir…",
  "server.secret.set": "definida",
  "server.secret.unreadable": "La clave guardada ya no se puede leer, probablemente porque cambió la clave secreta del servidor. Vuelve a introducirla.",
  "server.setting.KM_AUTO_EXTRACT": "Extraer automáticamente",
  "server.setting.KM_AUTO_EXTRACT.help": "Extraer una página en segundo plano después de cambiar, en los espacios de trabajo que no decidan otra cosa.",
  "server.setting.KM_DECISION_ACCEPT": "Aceptar desde",
  "server.setting.KM_DECISION_ACCEPT.help": "Una decisión con al menos esta seguridad ancla la entidad sin revisión.",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS": "Aceptar desde (logprobs)",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS.help": "Lo mismo para el protocolo logprobs, cuya seguridad no está calibrada. 1,1 nunca acepta.",
  "server.setting.KM_DECISION_BASE_URL": "Dirección",
  "server.setting.KM_DECISION_BASE_URL.help": "La dirección del servidor sin /v1, por ejemplo http://ollama:11434. Vacía desactiva el modelo de decisión.",
  "server.setting.KM_DECISION_COOLDOWN_S": "Pausa tras un fallo",
  "server.setting.KM_DECISION_COOLDOWN_S.help": "Cuánto tiempo se deja de consultar un endpoint que ha fallado.",
  "server.setting.KM_DECISION_MODEL": "Modelo",
  "server.setting.KM_DECISION_MODEL.help": "El nombre del modelo de decisión.",
  "server.setting.KM_DECISION_PROTOCOL": "Protocolo",
  "server.setting.KM_DECISION_PROTOCOL.help": "systemone para un endpoint de decisión de Ollama, logprobs para cualquier modelo de chat, auto prueba ambos.",
  "server.setting.KM_DECISION_TIMEOUT": "Tiempo de espera",
  "server.setting.KM_DECISION_TIMEOUT.help": "Cuánto se espera una respuesta, incluida la carga del modelo.",
  "server.setting.KM_EXTRACTION_MAX_NODES": "Bloques por ejecución",
  "server.setting.KM_EXTRACTION_MAX_NODES.help": "El máximo de bloques que lee una ejecución de extracción.",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES": "Texto de archivo por prompt",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES.help": "Cuánto de ese texto recibe un prompt. Los modelos locales pequeños necesitan poco.",
  "server.setting.KM_FILE_TEXT_MAX_BYTES": "Texto por archivo",
  "server.setting.KM_FILE_TEXT_MAX_BYTES.help": "Cuánto texto se guarda de un archivo adjunto.",
  "server.setting.KM_GRAPH_MAX_ROWS": "Filas por consulta",
  "server.setting.KM_GRAPH_MAX_ROWS.help": "El máximo de filas que devuelve una consulta.",
  "server.setting.KM_GRAPH_TIMEOUT_S": "Tiempo límite de consulta",
  "server.setting.KM_GRAPH_TIMEOUT_S.help": "Cuánto puede durar una consulta.",
  "server.setting.KM_LLM_API_KEY": "Clave de API",
  "server.setting.KM_LLM_API_KEY.help": "Se envía como token bearer. Una vez guardada, no se vuelve a mostrar.",
  "server.setting.KM_LLM_BASE_URL": "Dirección",
  "server.setting.KM_LLM_BASE_URL.help": "La dirección compatible con OpenAI del modelo, que termina en /v1. Solo se aceptan hosts de la lista de hosts permitidos del servidor.",
  "server.setting.KM_LLM_MODEL": "Modelo",
  "server.setting.KM_LLM_MODEL.help": "El nombre del modelo tal como lo conoce el endpoint.",
  "server.setting.KM_MCP_ENABLED": "Conector activado",
  "server.setting.KM_MCP_ENABLED.help": "Desactivado rechaza todos los tokens al instante y nadie puede crear otros nuevos.",
  "server.setting.KM_MCP_INLINE_MAX_BYTES": "Mayor subida en una llamada",
  "server.setting.KM_MCP_INLINE_MAX_BYTES.help": "Los archivos de hasta este tamaño pueden enviarse dentro de una llamada; los más grandes usan una dirección de subida.",
  "server.setting.KM_MCP_MAX_TOKENS": "Tokens por persona",
  "server.setting.KM_MCP_MAX_TOKENS.help": "El máximo de tokens válidos que puede tener una persona.",
  "server.setting.KM_MCP_RATE_LIMIT": "Llamadas por minuto",
  "server.setting.KM_MCP_RATE_LIMIT.help": "El máximo de llamadas a herramientas que puede hacer un token en un minuto.",
  "server.setting.KM_OIDC_LABEL": "Etiqueta del botón de Keycloak",
  "server.setting.KM_OIDC_LABEL.help": "El nombre en el botón de inicio de sesión de Keycloak.",
  "server.setting.KM_OIDC_REQUIRED_GROUP": "Grupo de Keycloak requerido",
  "server.setting.KM_OIDC_REQUIRED_GROUP.help": "Solo los miembros de este grupo pueden entrar con Keycloak. Vacío admite a todo el realm.",
  "server.setting.KM_PASSWORD_LOGIN": "Inicio con contraseña",
  "server.setting.KM_PASSWORD_LOGIN.help": "Desactivado deja solo el inicio con Keycloak. Los administradores siempre pueden entrar con contraseña.",
  "server.setting.KM_RAIL_BUNDLE_GROUPS": "Grupos de opciones",
  "server.setting.KM_RAIL_BUNDLE_GROUPS.help": "Si los conectores de un grupo de opciones van por un tronco común, con la etiqueta del grupo en él.",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP": "Conector en dos haces",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP.help": "Un conector que comparte su origen con unos y su destino con otros se une a un solo haz.",
  "server.setting.KM_SYNC_TOKEN_TTL_S": "Validez del token de sincronización",
  "server.setting.KM_SYNC_TOKEN_TTL_S.help": "Cuánto vale el token de sincronización de una página. Uno más corto termina antes el acceso de un miembro eliminado.",
  "server.setting.KM_TRANSFER_MAX_BYTES": "Tamaño de archivo",
  "server.setting.KM_TRANSFER_MAX_BYTES.help": "El archivo de páginas más grande que se puede importar.",
  "server.setting.KM_TRANSFER_TTL_S": "Archivos conservados durante",
  "server.setting.KM_TRANSFER_TTL_S.help": "Los archivos exportados e importados se borran después de este tiempo.",
  "server.setting.KM_WEB_BROWSING": "Navegación web",
  "server.setting.KM_WEB_BROWSING.help": "Desactivada detiene toda navegación en bloques de página web; las instantáneas congeladas siguen legibles.",
  "server.setting.KM_WEB_DOM_MAX_BYTES": "Tamaño del texto de la página",
  "server.setting.KM_WEB_DOM_MAX_BYTES.help": "El texto de página más grande que se guarda con una instantánea.",
  "server.setting.KM_WEB_RECORD_MAX_BYTES": "Tamaño de grabación",
  "server.setting.KM_WEB_RECORD_MAX_BYTES.help": "Lo máximo que puede grabar una sesión de navegación.",
  "server.setting.KM_WEB_SESSION_TTL_S": "Duración de una sesión de navegación",
  "server.setting.KM_WEB_SESSION_TTL_S.help": "Las grabaciones de sesiones más antiguas se borran; las instantáneas se conservan.",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES": "Tamaño de instantánea",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES.help": "La instantánea congelada más grande.",
  "server.setting.KM_WEB_TOKEN_IDLE_S": "La navegación inactiva termina tras",
  "server.setting.KM_WEB_TOKEN_IDLE_S.help": "Una sesión de navegación sin uso durante este tiempo deja de funcionar.",
  "server.source.default": "predeterminado",
  "server.source.environment": "entorno",
  "server.source.saved": "guardado aquí",
  "server.tab.history": "Historial",
  "server.tab.settings": "Ajustes",
  "server.tab.users": "Usuarios",
  "server.test": "Probar conexión",
  "server.test.answered": "{model} respondió en {ms} ms.",
  "server.test.format": "{model} respondió en {ms} ms, pero no en el formato pedido. La extracción valida igualmente cada respuesta.",
  "server.test.host": "{message} no está en la lista de hosts de modelos permitidos del servidor.",
  "server.test.http": "El endpoint respondió con un error: {message}",
  "server.test.model_missing": "Alcanzado, pero el endpoint no ofrece {model}. Ofrece: {message}",
  "server.test.patience": "Un modelo que aún no está cargado puede tardar uno o dos minutos.",
  "server.test.reached": "Alcanzado en {ms} ms; {model} está disponible.",
  "server.test.running": "Probando…",
  "server.test.timeout": "Sin respuesta en {message} s. Puede que el modelo aún se esté cargando; vuelve a intentarlo en un minuto.",
  "server.test.unparseable": "El endpoint respondió algo que no es JSON.",
  "server.test.unreachable": "No se puede alcanzar: {message}",
  "server.test.url": "Introduce primero una dirección http o https.",
  "server.title": "Ajustes del servidor",
  "server.users": "Usuarios",
  "server.users.admin": "Administrador",
  "server.users.col.lastLogin": "Último inicio",
  "server.users.col.signIn": "Inicia sesión con",
  "server.users.col.user": "Usuario",
  "server.users.col.workspaces": "Espacios de trabajo",
  "server.users.create": "Crear usuario",
  "server.users.deactivate": "Desactivar",
  "server.users.displayName": "Nombre visible",
  "server.users.edit": "Editar…",
  "server.users.editTitle": "Editar {user}",
  "server.users.email": "Correo electrónico",
  "server.users.field.displayName": "nombre visible",
  "server.users.field.email": "correo electrónico",
  "server.users.guard.lastAdmin": "El último administrador se queda.",
  "server.users.guard.oidc": "La contraseña de esta cuenta está en Keycloak.",
  "server.users.guard.self": "No para tu propia cuenta.",
  "server.users.inactive": "desactivada",
  "server.users.isAdmin": "Administrador: puede abrir los ajustes del servidor",
  "server.users.makeAdmin": "Hacer administrador",
  "server.users.mcpTokens": {
    "one": "{count} token MCP",
    "other": "{count} tokens MCP"
  },
  "server.users.menu": "Acciones para {user}",
  "server.users.never": "nunca",
  "server.users.new": "Nuevo usuario",
  "server.users.newPassword": "Nueva contraseña",
  "server.users.password": "Fijar contraseña…",
  "server.users.passwordTitle": "Nueva contraseña para {user}",
  "server.users.reactivate": "Reactivar",
  "server.users.refused.last_admin": "El servidor necesita al menos un administrador activo.",
  "server.users.refused.oidc": "Esta cuenta inicia sesión con Keycloak; su contraseña está allí.",
  "server.users.refused.self": "No puedes hacer eso con tu propia cuenta.",
  "server.users.refused.system": "Las cuentas del sistema no se pueden cambiar.",
  "server.users.refused.username_taken": "Este nombre de usuario ya existe.",
  "server.users.removeAdmin": "Quitar administrador",
  "server.users.revokeTokens": "Revocar todos los tokens MCP",
  "server.users.setPassword": "Fijar contraseña",
  "server.users.signIn.oidc": "Keycloak",
  "server.users.signIn.password": "contraseña",
  "server.users.sub": "Todas las cuentas de este servidor. Las membresías se fijan en la página de ajustes de cada espacio de trabajo.",
  "settings.confirm": "Confirmar",
  "settings.confirm.allow": "Permitir",
  "settings.confirm.auto.body": "Cada diez minutos, los bloques desactualizados se enviarán a <b>{host}</b>{model} sin preguntar a nadie. Esto cuesta lo que cueste ese servicio.",
  "settings.confirm.auto.title": "¿Extraer automáticamente?",
  "settings.confirm.egress.body": "La extracción podrá enviar el texto de las páginas de este espacio a <b>{host}</b>{model}{notListed}. Sigue desactivado para todos los demás espacios.",
  "settings.confirm.egress.title": "¿Permitir que el texto de las páginas salga de esta máquina?",
  "settings.confirm.notListed": ", que no está en la lista permitida del servidor",
  "settings.delete.body": "Eliminarlo lo oculta de inmediato a todos los miembros y desconecta a quien lo tenga abierto. Sus páginas, su historial y sus archivos se conservan, de modo que un administrador del servidor puede restaurarlo. Las páginas sueltas se eliminan desde la propia página y se restauran desde la papelera del espacio.",
  "settings.delete.button": "Eliminar espacio de trabajo…",
  "settings.delete.confirm.body": "Todos los miembros pierden de inmediato el acceso a <b>{name}</b> y a sus páginas. Escribe el nombre del espacio de trabajo para confirmar.",
  "settings.delete.confirm.label": "Nombre del espacio de trabajo",
  "settings.delete.confirm.ok": "Eliminar espacio de trabajo",
  "settings.delete.confirm.title": "¿Eliminar «{name}»?",
  "settings.delete.ownerOnly": "Solo un propietario puede eliminar este espacio de trabajo.",
  "settings.delete.title": "Eliminar este espacio de trabajo",
  "settings.members": "Miembros",
  "settings.members.add": "Añadir",
  "settings.members.already": "Esta persona ya es miembro.",
  "settings.members.ambiguous": "Varias personas tienen este nombre. Usa su nombre de usuario o su correo.",
  "settings.members.keycloak": "Keycloak: {name}",
  "settings.members.needServer": "Los miembros requieren el servidor.",
  "settings.members.newRole": "Rol del nuevo miembro",
  "settings.members.notFound": "Ninguna cuenta tiene este nombre de usuario, correo, inicio de Keycloak o nombre.",
  "settings.members.oidc": "Keycloak decide quién es miembro de este espacio: los cambios hechos aquí se sobrescriben en el siguiente inicio de sesión del miembro. El último propietario se conserva y se marca como <b>manual</b>.",
  "settings.members.remove": "Quitar a {user}",
  "settings.members.roleOf": "Rol de {user}",
  "settings.members.sub": "El acceso de lectura abarca todo el espacio: cada miembro puede leer todas las páginas.",
  "settings.members.who": "Usuario, correo o nombre",
  "settings.members.you": "(tú)",
  "settings.name": "Nombre",
  "settings.policy": "Políticas",
  "settings.policy.auto": "Extracción automática",
  "settings.policy.auto.body": "Cada diez minutos, los bloques cuya extracción está desactualizada se envían de nuevo al LLM. Los adjuntos nunca se procesan automáticamente. El predeterminado del servidor está {state}.",
  "settings.policy.egress": "Salida hacia el LLM",
  "settings.policy.egress.body": "La extracción puede usar un servicio fuera de la lista permitida del servidor. El texto de las páginas sale entonces de esta máquina hacia {host}{model}.",
  "settings.policy.endpoint": "el servicio configurado",
  "settings.policy.mcp": "Conectores MCP",
  "settings.policy.mcp.body": "Los asistentes de IA conectados con el token MCP de un miembro pueden leer este espacio de trabajo y, con permiso de escritura, cambiarlo. Desactivado, los tokens no ven nada de él.",
  "settings.policy.migrate": "Sustituir automáticamente los términos de ontología obsoletos",
  "settings.policy.migrate.body": "Cuando una ontología retira un término y nombra exactamente un sucesor seguro, KSS lo sustituye por sí solo en todas las páginas. Cada sustitución aparece en la bandeja de revisión, donde se puede deshacer. Lo que no esté tan claro sigue siendo una pregunta para una persona.",
  "settings.policy.off": "desactivada",
  "settings.policy.on": "activada",
  "settings.policy.serverDefault": "según el servidor",
  "settings.policy.web": "Navegación web",
  "settings.policy.web.body": "Los bloques de página web pueden navegar por páginas en vivo a través del proxy de grabación. Las instantáneas congeladas se muestran en cualquier caso.",
  "settings.readOnly": "Puedes ver la configuración de este espacio de trabajo; solo un propietario puede cambiarla.",
  "settings.rename": "Renombrar",
  "settings.restricted": "Páginas con escritura restringida",
  "settings.restricted.forYou": "solo lectura para ti",
  "settings.restricted.none": "Ninguna página restringe la escritura.",
  "settings.restricted.sub": "Las restricciones de escritura de una página se ajustan en la propia página, en «Restringir la escritura…».",
  "settings.title": "Configuración",
  "sync.connecting": "conectando…",
  "sync.error": "error de sincronización",
  "sync.forbidden": "sin acceso",
  "sync.offline": "sin conexión",
  "sync.synced": "sincronizado",
  "sync.syncing": "sincronizando…",
  "table.align.center": "Centrar",
  "table.align.left": "Alinear a la izquierda",
  "table.align.right": "Alinear a la derecha",
  "table.caption": "Título (opcional)",
  "table.colLeft": "Añadir una columna a la izquierda",
  "table.colRight": "Añadir una columna a la derecha",
  "table.copied": "Copiado",
  "table.copy": "Copiar como Markdown",
  "table.deleteColumn": "Eliminar la columna",
  "table.deleteRow": "Eliminar la fila",
  "table.rowAbove": "Añadir una fila encima",
  "table.rowBelow": "Añadir una fila debajo",
  "tb.bold": "Negrita (Ctrl/⌘+B)",
  "tb.bullet": "Lista con viñetas",
  "tb.code": "Código en línea (Ctrl/⌘+`)",
  "tb.formatting": "Formato",
  "tb.heading": "Encabezado {level}",
  "tb.indent": "Aumentar la sangría del elemento",
  "tb.italic": "Cursiva (Ctrl/⌘+I)",
  "tb.link": "Enlace",
  "tb.linkInvalid": "Solo se permiten enlaces http, https y mailto.",
  "tb.linkPrompt": "URL del enlace (https://…)",
  "tb.linkPromptEdit": "URL del enlace (vacía quita el enlace)",
  "tb.ordered": "Lista numerada",
  "tb.outdent": "Reducir la sangría del elemento",
  "tb.paragraph": "Párrafo",
  "tb.quote": "Cita",
  "tb.redo": "Rehacer",
  "tb.rule": "Línea horizontal",
  "tb.strike": "Tachado",
  "tb.undo": "Deshacer",
  "termPicker.free": "no es un término de la ontología",
  "trash.deletedOn": "eliminada el {date}",
  "trash.restore": "Restaurar",
  "trash.title": "Papelera ({count})",
  "tree.collapse": "Plegar la carpeta",
  "tree.copyFolderIri": "Copiar el IRI de la carpeta",
  "tree.copyPageIri": "Copiar el IRI de la página",
  "tree.deleteFolder": "Eliminar la carpeta",
  "tree.dissolve": "Disolver la carpeta",
  "tree.dragFolder": "Arrastrar carpeta",
  "tree.dragPage": "Arrastrar página",
  "tree.expand": "Desplegar la carpeta",
  "tree.folderTitle": "Nombre de la carpeta",
  "tree.intoFolderAbove": "Mover a la carpeta de arriba",
  "tree.items": {
    "one": "{count} elemento",
    "other": "{count} elementos"
  },
  "tree.menu": "Menú de la página",
  "tree.newFolder": "Nueva carpeta",
  "tree.newFolderHere": "Nueva carpeta aquí",
  "tree.newFolderTitle": "Nueva carpeta",
  "tree.newPageHere": "Nueva página aquí",
  "tree.outOfFolder": "Sacar de la carpeta",
  "urlBlock.action.browser": "abrir en el navegador",
  "urlBlock.action.copy": "copiar el enlace",
  "urlBlock.action.system": "abrir con la aplicación del sistema",
  "urlBlock.address": "Dirección",
  "urlBlock.caption": "Texto que se muestra como enlace (opcional)",
  "urlBlock.copied": "Enlace copiado",
  "urlBlock.empty": "sin dirección",
  "urlBlock.hint": "Escribe o pega una dirección abajo.",
  "urlBlock.noScheme": "añade un esquema como https://",
  "urlBlock.none": "Todavía no hay dirección.",
  "urlBlock.refused": "los enlaces {scheme}: no están permitidos",
  "urlBlock.systemHint": "para enlaces de aplicaciones como mailto: o zotero:; una dirección web se abre en el navegador",
  "urlBlock.whenClicked": "Al hacer clic",
  "video.badUrl": "No es una URL http(s) válida",
  "video.frame": "Vídeo",
  "video.load": "▶ Cargar el reproductor de {provider} ({id})",
  "video.placeholder": "Pega una URL de YouTube, Vimeo u otro vídeo",
  "web.back": "Atrás",
  "web.badAddress": "Introduce una dirección http(s).",
  "web.cannotOpen": "La página web no se puede abrir en este momento.",
  "web.empty": "Todavía no hay página web.",
  "web.emptyEdit": "Escribe una dirección arriba y pulsa Intro.",
  "web.forward": "Adelante",
  "web.freeze": "Congelar",
  "web.freezeFailed": "No se pudo congelar.",
  "web.freezeFailedWith": "No se pudo congelar: {error}",
  "web.freezeTitle": "Conservar esta página exactamente como está ahora",
  "web.freezing": "Congelando…",
  "web.frozenAt": "congelada el {date}",
  "web.noAddress": "Todavía no hay dirección",
  "web.noAnswer": "La página no respondió. Recárgala y vuelve a intentarlo.",
  "web.offline": "No disponible sin conexión: solo lo están las páginas congeladas.",
  "web.reload": "Recargar",
  "web.replay": "Reproducir el original",
  "web.replayTitle": "Volver a ejecutar la página grabada con sus scripts en lugar de mostrarla tal como se congeló",
  "web.showSnapshot": "Mostrar esta instantánea",
  "web.shown": "mostrada",
  "web.snapshotOffline": "Esta instantánea no está disponible sin conexión. Fija la página para conservarla.",
  "web.snapshots": {
    "one": "{count} instantánea",
    "other": "{count} instantáneas"
  },
  "web.unfreeze": "Descongelar",
  "web.usePage": "Usar esta página",
  "workspace.gone.body": "Un propietario lo eliminó, así que sus páginas ya no se pueden abrir ni editar. Pregunta al propietario o a la administración del servidor si debe volver.",
  "workspace.gone.home": "Volver a tus espacios de trabajo",
  "workspace.gone.title": "Este espacio de trabajo se eliminó",
  "ws.createPage": "Crear página",
  "ws.fallbackName": "Espacio de trabajo",
  "ws.list.create": "Crear",
  "ws.list.deleted": "«{name}» se eliminó.",
  "ws.list.deleted.undo": "Deshacer",
  "ws.list.empty": "Todavía no hay espacios de trabajo.",
  "ws.list.lead": "Cada página, cada enlace y cada dato vive en uno de estos.",
  "ws.list.newName": "Nombre del nuevo espacio",
  "ws.list.title": "Espacios de trabajo",
  "ws.nav.graph": "Grafo",
  "ws.nav.review": "Revisión",
  "ws.nav.settings": "Configuración",
  "ws.newPageTitle": "Título de la nueva página",
  "ws.noPages": "Todavía no hay páginas.",
  "ws.notInTree": "(fuera del árbol de páginas)",
  "ws.readOnly": "solo lectura"
}
